'use client'

import { LargeSuccessIcon } from '@repo/ui/LargeSuccessIcon'
import { SubmitCOISClientMatterWizard } from '@repo/ui/SubmitCOISClientMatterWizard'
import { useNotificationStore } from '@repo/store/useNotificationStore'
import { useState, useEffect } from 'react'
import { useWizardStore } from '@repo/store/useWizardStore'
import { useUrlStore } from '@repo/store/useUrlStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const COISSummary = ({ wideMode, handlePrevNext, updateStepState, wizardId, testMode = false }) => {
  // this screen may be the form submissions screen or the summary screen
  const screenMode = wizardId === 'COIS-ExistingClient-ExistingMatter' ? 'formSubmission' : 'summary'
  const [formStatus, setFormStatus] = useState(null)
  const { navigateWithClientMatterNo } = useUrlStore()
  const { isNotificationWizard } = useNotificationStore()
  const { reset: resetWizardStore } = useWizardStore()

  useEffect(() => {
    if (formStatus && formStatus !== 'error') updateStepState({ status: 'completed', statusText: 'Complete' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formStatus])

  const handleClickContinue = () => {
    if (screenMode === 'formSubmission') {
      if (!formStatus || formStatus === 'error') return
      resetWizardStore()

      // go to default matter page
      navigateWithClientMatterNo({ clientMatterNo: formStatus })
    } else {
      updateStepState({ status: 'completed', statusText: 'Complete' })
      handlePrevNext(1)
    }
  }

  const handleClickBack = () => {
    isNotificationWizard === true ? handlePrevNext(-2) : handlePrevNext(-1)
  }

  const isBackButtonVisible = () => {
    if (screenMode !== 'formSubmission') return true
    return !formStatus || formStatus === 'error'
  }

  return (
    <>
      {screenMode === 'formSubmission' ? (
        <SubmitCOISClientMatterWizard wizardId={wizardId} testMode={testMode} onStatusChange={setFormStatus} />
      ) : (
        <WizardPanel data-testid="COISSummary">
          <MUIStack
            direction="column"
            gap={4}
            justifyContent="center"
            alignItems="center"
            sx={{ height: '420px', maxWidth: '500px', margin: '0 auto' }}
          >
            <LargeSuccessIcon sx={{ width: '90px', height: '90px', mb: '32px' }} />

            <MUITypography variant="h4" sx={{ mb: 0 }}>
              Conflict of interest search successful
            </MUITypography>

            <MUITypography variant="body1" sx={{ mb: 0, textAlign: 'center' }}>
              The next step is to assign the search to an existing matter, or to create a new client/matter as needed.
            </MUITypography>
          </MUIStack>
        </WizardPanel>
      )}
      <WizardFooter
        wideMode={wideMode}
        handleClickContinue={handleClickContinue}
        handleClickBack={handleClickBack}
        continueButtonText={screenMode === 'formSubmission' ? 'Finish' : 'Continue'}
        continueButtonDisabled={Boolean(screenMode === 'formSubmission' && (!formStatus || formStatus === 'error'))}
        backButtonVisible={isBackButtonVisible()}
      />
    </>
  )
}

COISSummary.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  updateStepState: PropTypes.func,
  wizardId: PropTypes.string,
  testMode: PropTypes.bool
}
